import { render, staticRenderFns } from "./SpFourModule4.vue?vue&type=template&id=44a8e5be&scoped=true"
import script from "./SpFourModule4.vue?vue&type=script&lang=js"
export * from "./SpFourModule4.vue?vue&type=script&lang=js"
import style0 from "./SpFourModule4.vue?vue&type=style&index=0&id=44a8e5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a8e5be",
  null
  
)

export default component.exports